// Billing mode bootstrap — mirrors auth/firebase.ts.
//
//   'mock'   — no real payment SDK. openCheckout() hits the dev backend endpoint
//              POST /dev/subscription to grant the tier instantly. Default, so
//              the UI works offline with VITE_AUTH_MODE=mock.
//   'paddle' — loads Paddle.js and opens the real overlay checkout.

export type BillingMode = 'mock' | 'paddle';

export const billingMode: BillingMode =
  (import.meta.env.VITE_BILLING_MODE as BillingMode | undefined) === 'paddle' ? 'paddle' : 'mock';

/** Paddle price ids for the monthly tiers, supplied via env in paddle mode. */
export const paddleMonthlyPriceIds: Record<'premium' | 'ultra', string | undefined> = {
  premium: import.meta.env.VITE_PADDLE_PRICE_PREMIUM,
  ultra:   import.meta.env.VITE_PADDLE_PRICE_ULTRA,
};

/** Paddle price ids for the one-time "Full Journey" passes. */
export const paddleLifetimePriceIds: Record<'premium' | 'ultra', string | undefined> = {
  premium: import.meta.env.VITE_PADDLE_PRICE_FAMILY_LIFETIME,
  ultra:   import.meta.env.VITE_PADDLE_PRICE_VILLAGE_LIFETIME,
};
